import { convertPropClass2ClassObjectLike } from '../../core/utils/KProps'
import _ from 'lodash'

export default {
  name: 'KBadge',
  props: {
    // primary, secondary, warning, danger, success, light, dark
    type: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    showZero: {
      type: Boolean,
      default: false,
    },
    wave: {
      type: Boolean,
      default: false,
    },
    overflow: {
      type: Number,
      default: null,
    },
    dot: {
      type: Boolean,
      default: false,
    },
    badgeClass: {
      validator: (value) => _.isString(value) || _.isArray(value) || _.isObjectLike(value),
      // {}
      default() {
        return {}
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    finalBadgeClass() {
      return {
        'km-badge__item': true,
        'km-badge__item--fixed': !!this.$slots.default,
        'km-badge__item--custom': !!this.$slots.value,
        [`km-badge__item--${this.type}`]: !!this.type,
        ...convertPropClass2ClassObjectLike(this.badgeClass),
      }
    },
    content() {
      if (this.$slots.value) {
        return this.$slots.value
      }

      if (this.showZero && this.value === 0) {
        return '0'
      }

      if (_.isNumber(this.value) && this.overflow && this.value > this.overflow) {
        return `${this.overflow}+`
      }

      return this.value
    },
  },
  methods: {
    renderSup(css = {}) {
      return (
        <transition
          apper
          name="km-badge"
        >
          <sup
            v-show={this.content}
            class={{
              ...this.finalBadgeClass,
              ...css,
            }}
          >
            {this.dot ? null : this.content}
            {
              this.wave
                ? <div class="km-badge__wave"></div>
                : null
            }
          </sup>
        </transition>
      )
    },
  },
  render() {
    const css = {
      'km-badge': true,
      'km-badge--dot': this.dot,
    }

    const data = {
      class: css,
    }

    if (this.$slots.default) {
      return (
        <div
          {...data}
        >
          {this.$slots.default}
          {this.renderSup()}
        </div>
      )
    } else {
      return this.renderSup(css)
    }
  },
}
